//Contact.jsx:
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadSection from '../components/DownloadSection';
import Header from '../components/Header';
import './Contact.css';

function Contact() {
    const { t } = useTranslation(); // Translation hook

    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Create a ref for the DownloadSection
    const downloadRef = useRef(null);

    // Scroll function
    const scrollToDownload = () => {
        if (downloadRef.current) {
            downloadRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            {/* Pass scrollToDownload to Header */}
            <Header scrollToDownload={scrollToDownload} />

            {/* Contact Page Content */}
            <div className="contact-container">
                <h1>{t("contacts.title")}</h1>
                <p>{t("contacts.description")}</p>
                <p>{t("contacts.description1")}</p>

                <div className="contact-details">
                    <h2>{t("contacts.email")}</h2>
                    <p>📧 hello@app-ever.com</p>

                    <h2>{t("contacts.phone")}</h2>
                    <p>📞 +44 7872 635 307</p>

                    <h2>{t("contacts.address")}</h2>
                    <p>📍 Canada Water, London, UK</p>
                </div>
            </div>

            {/* Wrap DownloadSection in a ref for scrolling */}
            <div ref={downloadRef} className="download-section-anchor">
                <DownloadSection />
            </div>
        </div>
    );
}

export default Contact;
